import { Route, Switch } from 'react-router-dom';
import AnnouncementsList from './announcements-list';

function Squad() {
  return (
    <Switch>
      <Route exact path="/announcements" component={AnnouncementsList} />
    </Switch>
  );
}

export default Squad;
